import { render, staticRenderFns } from "./NormalSearchNav306.vue?vue&type=template&id=589d2afe&scoped=true&"
import script from "./NormalSearchNav306.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav306.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589d2afe",
  null
  
)

export default component.exports